import { IBudgetKanbanFilters } from "../../../models/budget";
import { useBudgetExport } from "../hooks/useBudgetExport";

import "../index.scss";

export const BudgetExportButton = (filters: IBudgetKanbanFilters) => {

    const { isExporting, handleExport } = useBudgetExport(filters);

    return (
        <>
            <button
                type="button"
                className="btn btn-default mt-[22px] budget-export-button"
                aria-label="Baixar planilha com orçamentos aprovados"
                onClick={handleExport}
                disabled={isExporting}
            >
                <span className={`rioglyph ${isExporting ? "rioglyph-refresh spinning" : "rioglyph-download"}`} aria-hidden="true" />
                <span className="budget-export-button__label">Baixar planilha com orçamentos aprovados</span>
            </button>
        </>
    )
}